import { styled, Box, Typography } from '@mui/material';

import { SubscriptionTrialInfoSize } from './types';
import { getColors, normalizeProgresValue } from './utils';

export const SubscriptionTrialInfoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const SubscriptionTrialInfoChipContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size' && prop !== 'restDays',
})<{ size: SubscriptionTrialInfoSize; restDays: number }>(
  ({ theme, size, restDays }) => ({
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.common.white,
    borderRadius: 24 / 2,
    position: 'relative',
    border: '2px solid',
    height: 25.5,
    overflow: 'hidden',
    borderColor: getColors(restDays).border,

    ...(size === 'small' && {
      height: 17.5,
    }),
  }),
);

export const SubscriptionTrialInfoChipProgress = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'totalDays' && prop !== 'restDays',
})<{ totalDays: number; restDays: number }>(({ totalDays, restDays }) => ({
  position: 'absolute',
  width: '100%',
  inset: 0,
  transform: `translateX(-${normalizeProgresValue(totalDays, restDays)}%)`,
  transformOrigin: 'left center',
  transition: 'transform 0.4s linear',
  backgroundColor: getColors(restDays).progress,
}));

export const SubscriptionTrialInfoChipLabelContainer = styled(Box)(
  ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 3),
    zIndex: 1,
  }),
);

export const SubscriptionTrialInfoChipLabelTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'size' && prop !== 'restDays',
})<{ size: SubscriptionTrialInfoSize; restDays: number }>(
  ({ theme, size, restDays }) => ({
    ...theme.typography.caption,
    fontSize: theme.typography.pxToRem(12),
    color: getColors(restDays).text,

    ...(size === 'small' && {
      fontSize: theme.typography.pxToRem(10),
    }),
  }),
);
